import { render, staticRenderFns } from "./unmark.vue?vue&type=template&id=78038daa&scoped=true"
import script from "./unmark.vue?vue&type=script&lang=js"
export * from "./unmark.vue?vue&type=script&lang=js"
import style0 from "./unmark.vue?vue&type=style&index=0&id=78038daa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78038daa",
  null
  
)

export default component.exports